var $5ca94db2a021a726$exports = {};
$5ca94db2a021a726$exports = {
    "loading": `Na\u{10D}\xedtava sa...`,
    "placeholder": `Vybra\u{165}\u{2026}`
};


export {$5ca94db2a021a726$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
